import { FC } from 'react';
import CardList from '../CardList';
import { CommonAttributesProps } from 'screens/AccessExpressV3/accessExpress.types';
import { SelectedAttributes } from './mobility.types';

interface SecondaryPlanProps extends CommonAttributesProps {
  selected: SelectedAttributes['secondaryPlan'];
  setSelected: (v: SelectedAttributes['secondaryPlan']) => void;
}

const SecondaryPlan: FC<SecondaryPlanProps> = ({
  handleStep,
  step,
  selected,
  setSelected,
}) => {
  const onSelect = (item: SelectedAttributes['secondaryPlan']) => {
    handleStep && handleStep(step ?? 1);
    setSelected(item);
  };

  return (
    <>
      <CardList
        title="Secondary plan required for failover?"
        selected={selected}
        onClick={(item) =>
          onSelect(item as SelectedAttributes['secondaryPlan'])
        }
        options={[
          {
            id: 'yes',
            title: 'Yes',
          },
          {
            id: 'no',
            title: 'No',
          },
        ]}
      />
    </>
  );
};

export default SecondaryPlan;
